
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faInfo } from '@fortawesome/free-solid-svg-icons';

import 'Features/PickAndMix/components/Cards/PickAndMixSteamDeckIcons.scss';

const PickAndMixSteamDeckIcons = ({ siteTheme, steamDeckSupport }) => {
  if (steamDeckSupport !== 'playable' && steamDeckSupport !== 'verified') return false;


  return (
    <div className="PickAndMixCardSteamDeckIcons">
      <div className="PickAndMixCardSteamDeckIcons__logo">
        <img src={`https://cdn.fanatical.com/production/icons/steam-deck/${siteTheme === 'dark' ? 'light' : 'dark'}/steam-deck-icon.svg`} alt="Steam Deck" loading="lazy" />
      </div>
      {steamDeckSupport === 'verified' &&
        <div className="PickAndMixCardSteamDeckIcons__icon PickAndMixCardSteamDeckIcons__icon--verified">
          <FontAwesomeIcon icon={faCheck} />
        </div>
      }
      {steamDeckSupport === 'playable' &&
        <div className="PickAndMixCardSteamDeckIcons__icon PickAndMixCardSteamDeckIcons__icon--playable">
          <FontAwesomeIcon icon={faInfo} />
        </div>
      }
    </div>
  );
};

PickAndMixSteamDeckIcons.propTypes = {
  siteTheme: PropTypes.string,
  steamDeckSupport: PropTypes.oneOf(['playable', 'verified']),
};

PickAndMixSteamDeckIcons.defaultProps = {
  steamDeckSupport: 'playable',
  siteTheme: 'dark',
};

export default PickAndMixSteamDeckIcons;
